<template>
  <div>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      v-model="showAddControlGroupSearchesModal"
      :title="'PRI Simulation For Control Groups'"
    >
      <div>
        <!-- <b-col cols="6">
            <b-form-group label="Client">
              <v-select
                :searchable="true"
                :clearable="true"
                label="text"
                code="value"
                :class="$v.form.clientId.$error ? 'border border-danger rounded' : null"
                v-model="$v.form.clientId.$model"
                :state="$v.form.clientId.$dirty ? !$v.form.clientId.$error : null"
                aria-describedby
                :options="clientsOptions"
                @input="getControlGroupOptions"
                placeholder="Select Any Company"
              ></v-select>
            </b-form-group>
        </b-col>-->
        <div v-if="!submiting && !responseSuccess">
          <b-form-group label="Select Control Group:">
            <v-select
              :searchable="true"
              :clearable="true"
              :multiple="true"
              label="text"
              :class="$v.form.selectedControlGroup.$error ? 'border border-danger rounded' : null"
              v-model="$v.form.selectedControlGroup.$model"
              :state="$v.form.selectedControlGroup.$dirty ? !$v.form.selectedControlGroup.$error : null"
              aria-describedby
              :options="controlGroupOptions"
              @input="onSelectControlGroupId"
              placeholder="Select Control Group"
            >
              <template slot="option" slot-scope="option">
                <span>{{ '&nbsp;'+ option.text }}</span>
              </template>
            </v-select>
          </b-form-group>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Your Search is being submiting......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Your Search has been submited successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          variant="outline-danger"
          class="mr-3"
          @click="resetSearchSubmitModal"
        >{{!submiting && !responseSuccess ? 'Cancel' : 'Close'}}</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="checkValidation()"
        >Create</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { HTTP } from "../../../utils/HTTP";
import vSelect from "vue-select";
import { EventBus } from "@/event-bus.js";
export default {
  name: "AddPriSimulationControlGroupModel",
  mixins: [validationMixin],
  components: {
    vSelect,
  },
  data() {
    return {
      showAddControlGroupSearchesModal: false,
      form: {
        // clientId: null,
        selectedControlGroup: [],
      },
      clientsOptions: [],
      controlGroupOptions: [],
      isLoading: false,
      selectControlGroupValue: [],
      responseSuccess: false,
      submiting: false,
    };
  },

  validations: {
    form: {
      //   clientId: {
      //     required,
      //   },
      selectedControlGroup: {
        required,
      },
    },
  },
  created() {
    EventBus.$on("onShowAddControlGroupSearchesModal", (value) => {
      this.showAddModal();
    });
  },

  computed: {},

  mounted() {
    // this.getClientsList();
    this.getControlGroupOptions();
  },
  methods: {
    showAddModal() {
      this.showAddControlGroupSearchesModal = true;
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "control-group-searches-table");
    },
    // async getClientsList() {
    //   this.isLoading = true;
    //   let token = "Bearer " + localStorage.getItem("accessToken");
    //   try {
    //     let result = await HTTP("get", "v1/getclientslist", null, {
    //       Authorization: token,
    //     });

    //     this.clientsOptions = result.data.clients;
    //     this.isLoading = false;
    //   } catch (error) {
    //     this.isLoading = false;
    //   }
    // },
    async getControlGroupOptions() {
      this.controlGroupOptions = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/control-group/get/benchmark/control/group",
          null,
          {
            Authorization: token,
          }
        );
        this.controlGroupOptions = result.data.controlgroup;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    onSelectControlGroupId(value) {
      this.selectControlGroupValue = [];
      value.map((controlGroupValue) => {
        this.selectControlGroupValue.push(controlGroupValue.value);
      });
    },
    resetForm() {
      this.form = {
        // clientId: null,
        selectedControlGroup: [],
      };
      this.selectControlGroupValue = [];
      this.$v.$reset();
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.saveControlGroupSearch().then(this.reloadTable);
      }
    },
    async saveControlGroupSearch() {
      let formData = {
        control_group_ids: this.selectControlGroupValue,
        user_id: localStorage.getItem("userId"),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let token = "Bearer " + localStorage.getItem("accessToken");
        let result = await HTTP(
          "post",
          "v1/control-group/create-control-group-search",
          formData,
          {
            Authorization: token,
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        this.resetForm();
      } catch (err) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
      }
    },
    resetSearchSubmitModal() {
      this.resetForm();
      this.showAddControlGroupSearchesModal = false;
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.pri-row {
  height: calc(100vh - 150px);
  overflow-y: scroll;
}
</style>
